import { render, staticRenderFns } from "./UcPropertyEditorFieldset.yaml?vue&type=template&id=cf13a0dc&component"
import script from "./UcPropertyEditorFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./UcPropertyEditorFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports